<template>
  <Modal v-model="modal" :title="title" width="700">
    <Form ref="form" :model="form" :rules="rule" :label-width="100">
      <FormItem :label="$t('name.news.title')" prop="title">
        <Input v-model="form.title" />
      </FormItem>
      <FormItem :label="$t('name.news.content')" prop="content">
        <Input v-model="form.content" type="textarea" :rows="10" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" :loading="loading" @click="onPost">{{ title }}</Button>
    </div>
  </Modal>
</template>
<script>
import { put } from '@/api/news'

export default {
  computed: {
    title() {
      return this.form.id ? this.$t('name.update') : this.$t('name.create') 
    }
  },
  data() {
    return {
      modal: false,
      loading: false,
      form: {},
      field: {
        title: '',
        content: ''
      },
      rule: {
        title: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        content: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    open(data) {
      this.modal = true

      if(!data) {
        // 初始化字段
        data = Object.assign({}, this.field)
      }
      // 深拷贝
      this.form = Object.assign({}, data)

      // 清空验证
      this.$refs.form.resetFields()
    },
    close() {
      this.modal = false
    },
    onPost() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          put(this.form).then(res => {
            this.close()
            this.loading = false
            this.$Message.success(this.$t('message.' + res.message))
            this.$emit('get')
          }).catch(res => {
            this.loading = false
            this.$Message.error(this.$t('message.error.' + res.message))
          })
        }
      })
    }
  }
}
</script>